module.exports = __webpack_public_path__ + "img/dropdown-arrow.34a29adb.svg";